import { useTranslation } from 'react-i18next';
import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';

import { PlasseringAvEnhetIByggVertikalt } from '../../../../../../components/registering/utils/registerEnums';
import { useOmBoligenFormContext } from '../utils';

export const VertikalPlasseringLeilighetRadio = () => {
  const { t } = useTranslation();
  const { register, formState } = useOmBoligenFormContext();

  const vertikalPlasseringRegister = register('bygginfo.verticalPlacement', {
    required: t('register.errorMessage.field.vertikalPlassering'),
    shouldUnregister: true
  });

  const error = formState.errors.bygginfo?.verticalPlacement?.message;

  return (
    <Fieldset>
      <Fieldset.Legend>
        {t('register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggVertikalt.label')}
      </Fieldset.Legend>
      <Radio
        {...vertikalPlasseringRegister}
        aria-invalid={!!error}
        value={PlasseringAvEnhetIByggVertikalt.OversteEtasje}
        label={t(
          `register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggVertikalt.option.${PlasseringAvEnhetIByggVertikalt.OversteEtasje}`
        )}
      />
      <Radio
        {...vertikalPlasseringRegister}
        aria-invalid={!!error}
        value={PlasseringAvEnhetIByggVertikalt.MellomliggendeEtasje}
        label={t(
          `register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggVertikalt.option.${PlasseringAvEnhetIByggVertikalt.MellomliggendeEtasje}`
        )}
      />
      <Radio
        {...vertikalPlasseringRegister}
        aria-invalid={!!error}
        value={PlasseringAvEnhetIByggVertikalt.NedersteEtasje}
        label={t(
          `register.bygningsdetaljer.leilighet.plasseringAvEnhetIByggVertikalt.option.${PlasseringAvEnhetIByggVertikalt.NedersteEtasje}`
        )}
      />
      {error && <ValidationMessage data-color="danger">{error}</ValidationMessage>}
    </Fieldset>
  );
};
